import API from "../api/manager";
import config from "../api/config";

const setConfig = (data) => {
  return API({
    method: "POST",
    url: config.urls.systemConfig,
    data,
  });
};

const getConfig = () => {
  return API(
    {
      method: "GET",
      url: `${config.urls.systemConfig}?role=agent`,
    },
    false,
  );
};

const getProfile = (id) => {
  return API({
    method: "GET",
    url: config.urls.user.index + `/${id}`,
  });
};

const getConfigAuth = () => {
  return API({
    method: "GET",
    url: config.urls.systemConfig,
  });
};

const fetchWebinarConfigs = (query) => {
  return API(
    {
      method: "GET",
      url: config.urls.webinarConfig + query,
    },
    false,
  );
};

const fetchWebinarConfigById = (id) => {
  return API(
    {
      method: "GET",
      url: `${config.urls.webinarConfig}/${id}`,
    },
    false,
  );
};

export default {
  getConfig,
  setConfig,
  getProfile,
  getConfigAuth,
  fetchWebinarConfigById,
  fetchWebinarConfigs,
};
